import React from "react";
const colorTheme = {
  primary: "#667eea",
  success: "#10b981",
  error: "#ef4444",
  warning: "#f59e0b",
  info: "#06b6d4",
  gray50: "#f9fafb",
  gray100: "#f3f4f6",
  gray200: "#e5e7eb",
  gray300: "#d1d5db",
  gray400: "#9ca3af",
  gray500: "#6b7280",
  gray600: "#4b5563",
  gray700: "#374151",
  gray800: "#1f2937",
  gray900: "#111827",
  cardBg: "#ffffff",
  bgGradient: "linear-gradient(135deg, #E0F7FA 0%, #80DEEA 100%)",
  successGradient: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
  // cardBg: "#ffffff",
  emergencyBg: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
};

export default colorTheme;
